import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import { isMobile } from "react-device-detect";
import Lucky7Result from "../../client/tp-studio/tp-result/Lucky7Result.jsx";
import LuckyRules from "./pop-up/lucky7-rules.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Lucky7Virtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);

  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);

  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [b7Val, setB7Val] = useState(0);
  const [b8Val, setB8Val] = useState(0);
  const [b9Val, setB9Val] = useState(0);
  const [b10Val, setB10Val] = useState(0);
  const [b11Val, setB11Val] = useState(0);
  const [roundId, setRoundId] = useState("");

  const [sevenDown, setSevenDown] = useState(0);
  const [sevenUp, setSevenUp] = useState(0);
  const [tieCard, setTieCard] = useState(0);
  const [red, setRed] = useState(0);
  const [black, setBlack] = useState(0);
  const [odd, setOdd] = useState(0);
  const [even, setEven] = useState(0);
  const [club, setClub] = useState(0);
  const [diamond, setDiamond] = useState(0);
  const [heart, setHeart] = useState(0);
  const [spade, setSpade] = useState(0);

  const [sevenDownWinner, setSevenDownWinner] = useState(false);
  const [sevenUpWinner, setSevenUpWinner] = useState(false);
  const [tieCardWinner, setTieCardWinner] = useState(false);

  const [redWinner, setRedWinner] = useState(false);
  const [blackWinner, setBlackWinner] = useState(false);
  const [oddWinner, setOddWinner] = useState(false);
  const [eveWinner, setEvenWinner] = useState(false);
  const [clubWinner, setClubWinner] = useState(false);
  const [diamondWinner, setDiamondWinner] = useState(false);
  const [heartWinner, setHeartWinner] = useState(false);
  const [spadeWinner, setSpadeWinner] = useState(false);
  const [lastStatus, setLastStatus] = useState(null);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const [cardSettled, setCardSettled] = useState(false);
  const lastEvtStatusRef = useRef(null);
  const cardSettleTimerRef = useRef(null);

  let result = "";

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "lucky7_virtual"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  console.log("data:", payload); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    if (!payload) return;

    updateUserData(data?.user);

    setDisplayLoader(false);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setSevenDown(0);
      setTieCard(0);
      setSevenUp(0);
      setRed(0);
      setBlack(0);
      setOdd(0);
      setEven(0);
      setClub(0);
      setDiamond(0);
      setHeart(0);
      setSpade(0);

      setSevenDownWinner(false);
      setSevenUpWinner(false);
      setTieCardWinner(false);

      setRedWinner(false);
      setBlackWinner(false);
      setOddWinner(false);
      setEvenWinner(false);
      setClubWinner(false);
      setDiamondWinner(false);
      setHeartWinner(false);
      setSpadeWinner(false);
      setCardSettled(false);
      clearTimeout(cardSettleTimerRef.current);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setB7Val(payload?.b7);
    setB8Val(payload?.b8);
    setB9Val(payload?.b9);
    setB10Val(payload?.b10);
    setB11Val(payload?.b11);
    setRoundId(payload?.cat_mid);

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }
    result = payload?.result;
    if (result != "") {
      if (result == 1) {
        setSevenDownWinner(true);
      } else if (result == 2) {
        setSevenUpWinner(true);
      } else if (result == 3) {
        setTieCardWinner(true);
      }

      let card = payload?.c1;
      if (card !== "") {
        const lastTwo = card.slice(-2);

        if (lastTwo == "HH" || lastTwo == "CC") {
          setBlackWinner(true);
          if (lastTwo == "HH") {
            setSpadeWinner(true);
          }
          if (lastTwo == "CC") {
            setClubWinner(true);
          }
        } else {
          setRedWinner(true);
          if (lastTwo == "SS") {
            setDiamondWinner(true);
          }
          if (lastTwo == "DD") {
            setHeartWinner(true);
          }
        }
        let removeLastTwo = card.slice(0, -2);
        if (removeLastTwo == "K") {
          removeLastTwo = 13;
        } else if (removeLastTwo == "Q") {
          removeLastTwo = 12;
        } else if (removeLastTwo == "J") {
          removeLastTwo = 11;
        } else if (removeLastTwo == "A") {
          removeLastTwo = 1;
        }
        if (removeLastTwo % 2 == 0) {
          setEvenWinner(true);
        } else {
          setOddWinner(true);
        }
      }
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "lucky7_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        const name = String(books[i].name || "").toLowerCase();
        const bookValue = books[i].lay ?? 0;

        if (name === "7up") {
          setSevenUp(bookValue);
        } else if (name === "7down") {
          setSevenDown(bookValue);
        } else if (name === "tie card") {
          setTieCard(bookValue);
        } else if (name === "red") {
          setRed(bookValue);
        } else if (name === "black") {
          setBlack(bookValue);
        } else if (name === "odd") {
          setOdd(bookValue);
        } else if (name === "even") {
          setEven(bookValue);
        } else if (name === "club") {
          setClub(bookValue);
        } else if (name === "diamond") {
          setDiamond(bookValue);
        } else if (name === "heart") {
          setHeart(bookValue);
        } else if (name === "spade") {
          setSpade(bookValue);
        }
      }
    }
  }

  /* ================= SINGLE CARD UPDATE + FLIP ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;
    lastEvtStatusRef.current = payload.evt_status;

    if (payload?.c1) {
      setShownCard(payload.c1);
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);
      setCardSettled(false);
      clearTimeout(cardSettleTimerRef.current);
      cardSettleTimerRef.current = setTimeout(() => {
        setCardSettled(true);
      }, 1000);
    } else {
      setShouldFlip(false);
      setCardSettled(false);
      clearTimeout(cardSettleTimerRef.current);
    }
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "lucky7_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "lucky7_virtual"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const displayResult = (index) => {
    let txt = "";
    if (index == 1) {
      txt = "L";
    } else if (index == 2) {
      txt = "H";
    } else {
      txt = "T";
    }

    return txt;
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "lucky7_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const ShowWinner = () => {
    let returnTxt = "";
    if (sevenDownWinner) {
      returnTxt = "7Down";
    } else if (sevenUpWinner) {
      returnTxt = "7Up";
    } else if (tieCardWinner) {
      returnTxt = "7 Winner";
    }

    return returnTxt;
  };

  //console.log("resultList:", resultList);

  return (
    <div className="lucky7-virtual-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          {" "}
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer  h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>7UpDown</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                                <LuckyRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div className="cards-layout blackjack">
                              <div className="col-12 timerDiv2">
                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div
                                    className="col-2 col-md-1"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                              M 50, 50
                                              m -45, 0
                                              a 45,45 0 1,0 90,0
                                              a 45,45 0 1,0 -90,0
                                            "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="table-player mt-0"
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <span
                                  className="name player-dt"
                                  style={{
                                    display:
                                      ShowWinner() != "" ? "block" : "none"
                                  }}
                                >
                                  Winner = {ShowWinner()}
                                </span>
                                <div className="player player-card">
                                  <div className="tp-hand-single">
                                    <div
                                      className={`tp-card ${
                                        shouldFlip && payload?.c1 != "1"
                                          ? "flip"
                                          : ""
                                      }`}
                                    >
                                      <img
                                        src={`/assets/images/cards/${payload?.c1}.svg`}
                                        draggable={false}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  textAlign: "right",
                                  marginRight: "20px",
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                                className="volume-wrapper"
                              >
                                <Volume />
                              </div>
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3
                                  className={
                                    sevenUpWinner && cardSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                7Up
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    sevenUp !== 0 ? "" : "none",
                                                  color:
                                                    sevenUp > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(sevenUp)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="7Up"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "7Up",
                                        "7Up",
                                        b1Val,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    tieCardWinner && cardSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                7
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    tieCard !== 0 ? "" : "none",
                                                  color:
                                                    tieCard > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(tieCard)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="tie card"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "tie card",
                                        "tie card",
                                        b3Val,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {b3Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    sevenDownWinner && cardSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                7Down
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    sevenDown !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    sevenDown > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(sevenDown)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="7Up"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "7Down",
                                        "7Down",
                                        b1Val,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*- plus -*/}
                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>COLOR </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  oddWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Red
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  red !== 0 ? "" : "none",
                                                color:
                                                  red > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(red)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="red"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "red",
                                      "red",
                                      b6Val,
                                      "m",
                                      2
                                    )
                                  }
                                >
                                  {b6Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  eveWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Black
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  black !== 0 ? "" : "none",
                                                color:
                                                  black > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(black)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="black"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "black",
                                      "black",
                                      b7Val,
                                      "m",
                                      2
                                    )
                                  }
                                >
                                  {b7Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>ODD EVEN</span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  redWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Odd
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  odd !== 0 ? "" : "none",
                                                color:
                                                  odd > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(odd)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Odd"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "odd",
                                      "odd",
                                      b4Val,
                                      "m",
                                      3
                                    )
                                  }
                                >
                                  {b4Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  blackWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                                id="b3Sucess"
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Even
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  even !== 0 ? "" : "none",
                                                color:
                                                  even > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(even)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Even"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "even",
                                      "even",
                                      b5Val,
                                      "m",
                                      3
                                    )
                                  }
                                >
                                  {b5Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/*- plus -*/}
                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>SUIT </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  clubWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Club
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  club !== 0 ? "" : "none",
                                                color:
                                                  club > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(club)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="club"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "club",
                                      "club",
                                      b8Val,
                                      "m",
                                      4
                                    )
                                  }
                                >
                                  {b8Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  diamondWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Diamond
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  diamond !== 0 ? "" : "none",
                                                color:
                                                  diamond > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(diamond)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="diamond"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "diamond",
                                      "diamond",
                                      b9Val,
                                      "m",
                                      4
                                    )
                                  }
                                >
                                  {b9Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  heartWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Heart
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  heart !== 0 ? "" : "none",
                                                color:
                                                  heart > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(heart)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="heart"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "heart",
                                      "heart",
                                      b10Val,
                                      "m",
                                      4
                                    )
                                  }
                                >
                                  {b10Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  spadeWinner && cardSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Spade
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              id="bstatus1"
                                              style={{
                                                float: "left",
                                                display:
                                                  spade !== 0 ? "" : "none",
                                                color:
                                                  spade > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(spade)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="spade"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "spade",
                                      "spade",
                                      b11Val,
                                      "m",
                                      4
                                    )
                                  }
                                >
                                  {b11Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*- plus -*/}
                      </div>

                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <Lucky7Result resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4 ">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}

                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`

          .player-scope .table-player .player {
              width: 188px;
              height: 93px;
            
          }
            .player-scope .tp-card {
              top: 25px;
              align-items: center;
                    }
              .player-scope .tp-card img{
              height: 75px;
              }
          .cards-tp-card {
            margin-top: 0px;
          }
            .player-scope .table-player {
          gap: 9px !important;
           align-items: center;
           display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto !important;
  min-height: auto !important;
        }
          .player-scope .table-player .player-dt {
            display: flex !important;
            flex-direction: column;
            align-items: center !important;
            max-width: none;
            width: auto;
            color: #d7bc7b !important;
            font-size: 12px;
            font-weight: 700;
          }
          .tb-content{
            padding-top:3px;
          }

          .lucky7-virtual-scope .home-content {
            margin-top: 0 !important;
          }

          .lucky7-virtual-scope .timerDiv2 {
            padding-top: 0 !important;
          }

          .lucky7-virtual-scope .teenpatti-base-timer {
            position: relative;
            top: -5px;
            left: 10px;
          }

          .lucky7-virtual-scope .cards-layout.blackjack {
            position: relative;
            background: #000000;
          }

          .lucky7-virtual-scope .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 40px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }

          .lucky7-virtual-scope .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }

          .lucky7-virtual-scope .volume-wrapper {
            position: relative;
            top: 10px;
            left: 5px;
            margin-right: 25px !important;
          }

          .lucky7-virtual-scope .volume-wrapper .sound-icon {
            position: relative;
            top: auto;
            right: auto;
            transform: scale(0.9);
            transform-origin: center;
          }

/* ---------------- DESKTOP ---------------- */

        @media (min-width:992px){
          .table-player .player-name{
            font-size:13px;
          }
          .market-titlebar .market-name-badge span,
          .market-titlebar .market-overarround strong,
          .market-titlebar .market-overarround-lay strong{
            font-size:14px;
          }
          .player-scope .tp-hand {
            position: relative;
            width: 180px !important;
            height: 100px !important;
            margin: 10px -10px;
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);
          }
          .aviator-scope .row{
            margin-left:0 !important;
            margin-right:0 !important;
          }
          .col-md-8{
            padding-left:19px !important;
            margin-bottom:9px;
          }
          .left-content{
            padding-right:6px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .left-content .market-titlebar {
            width: 100%;
            display: flex;
            height: 20px;
          }
          .runner-runner .lobby-btn {
            height: 38px !important;
            min-height: 38px !important;
            padding: 2px 4px !important;
          }
          .cards-layout.blackjack {
            min-height: 210px;
          }
          .volume-wrapper {
            margin-top: -35px;
          }
        }

/* ---------------- MOBILE---------------- */
        @media (max-width:991px){
          .table-player{
            font-size:16px !important;
          }
          .market-titlebar strong{
            font-size:13px;
          }
          .col-md-8{
            padding-left:15px !important;
          }
          .left-content{
            padding-right:0;
          }
        }
        @media (max-width:576px){

          .left-content{
            margin-left: 5px;
            margin-right: 5px;
          }
          .cards-layout.blackjack {
            min-height: 130px !important;
          }
          .player-scope .cards-tp-card img{
            height: 50px;   
            width: auto;
            border-radius: 6px;
          }
          .player-scope .tp-hand {
            position: relative;
            width: 150px !important; 
            height: 60px !important;  
            margin: 4px 4px;    
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);     
          }
          .footer-divbpg{
            display:flex;
            align-items:center;
            justify-content:space-between;
            flex-wrap:nowrap; 
            border-radius:8px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .titlebarname p{
            font-size:18px !important;
          }
          .player-scope .table-player {
            justify-content: center; 
            gap: 1px !important;  
            padding: 0 10px !important;         
          }
          .btn-group-sm .btn{
            padding:2px 6px;
            font-size:12px;
          }
          .btn-group{
            flex-wrap:nowrap !important;
          }
          .footer-divbpg .btn-group-sm .btn{
            padding:6px 4px !important;
            font-size:12px !important;
            line-height:1.2;
            margin-top: 0;
          }
          .footer-divbpg .titlebarname{
            flex:1;         
            max-width:none !important;
            padding-left:4px;
          }
          .titlebarname p{
            font-size:17px !important;
            margin:0;
            margin-bottom: 12px;
            margin-left: 18px;
          }
          .tp20-player{
            width:48% !important;  
          }
          .tp20-hand{
            width:100% !important;
          }
          @scope (.aviator-scope) {
            .video-button {
              padding: 0px;
              background-color: #4f4f4f;
              color: #fff;
              font-family: Montserrat-ExtraBold;
              font-size: 12px !important;
              font-style: normal;
              font-weight: 500;
              height: 35px !important;
              margin-right: 3px;
              text-align: center;
              width: 1px !important;
              max-width: auto;
            }
          }
        }
          @media (max-width: 768px) {
            .lucky7-virtual-scope ul.top-nav,
            .lucky7-virtual-scope .top-nav {
              padding-left: 0 !important;
            }

            .lucky7-virtual-scope .volume-wrapper {
              top: -3px;
            }

            .timerDiv2 {
              margin-bottom: 0 !important;
            }
            .footer-divbpg {
              margin-top: 0 !important;
            }
            .volume-wrapper {  
              height: 10px !important;
              margin-top: -7px !important;
              line-height: 16px;
              margin-bottom: 10px;
            }
          }
        
        .tp-hand {
          display: flex;
          justify-content: center; 
          align-items: center; 
        }
    
      `}
      </style>
    </div>
  );
}
